import { useCallback, useEffect, useMemo } from 'react';
import { useSocket } from '../context';

export const useSocketEvent = function <T = unknown>(
  channel: string,
  handler: (data: T) => void
) {
  const socket = useSocket();
  const sub = useMemo(() => {
    return socket?.getSubscription(channel) ?? socket?.newSubscription(channel);
  }, [socket, channel]);

  const handleEvent = useCallback((data: T) => handler(data), [handler]);

  useEffect(() => {
    if (!sub) return;

    sub?.on('publication', function (ctx) {
      // console.log('publishing:', ctx.channel, ctx.data, ctx.info, ctx.offset);
      handleEvent(ctx.data);
    });
    // .on('subscribing', function (ctx) {
    // console.log(`subscribing: ${ctx.code}, ${ctx.reason}`);
    // })
    // .on('subscribed', function (ctx) {
    // console.log('subscribed', ctx);
    // })
    // .on('unsubscribed', function (ctx) {
    // console.log(`unsubscribed: ${ctx.code}, ${ctx.reason}`);
    // });
    return () => {
      sub?.unsubscribe();
    };
  }, [sub, handleEvent]);
};
